import cx from 'classnames'
import type React from 'react'
import { useSelector } from 'react-redux'

import type { AppState } from '@/types'
import { getDragAndDropAttributes } from '../../DragAndDrop/getDragAndDropAttributes'
import { DRAGGABLE_TYPE, DROPZONE_TYPE } from '../../DragAndDrop/types'
import css from './Dropzone.module.scss'

type Props = {
  type: 'before' | 'after'
  node: {
    group: string
    parentId: string
    childIndex: number
  }
}

const Dropzone: React.FC<Props> = ({ type, node }) => {
  const id = `${node.group}_${node.parentId}_${node.childIndex}_${type}`

  const isOver = useSelector<AppState, boolean>(
    ({ artboard }) =>
      id === artboard.dragAndDrop.dropZone.id &&
      artboard.dragAndDrop.dragged.type === DRAGGABLE_TYPE.PAGE
  )

  const dragAndDropIsStarted = useSelector<AppState, boolean>(
    ({ artboard }) => artboard.dragAndDrop.isStarted
  )

  return (
    <div
      data-compact-dropzone={type}
      className={cx(css.container, {
        [css.before]: type === 'before',
        [css.after]: type === 'after',
        [css.active]: isOver,
        [css.disable]: !dragAndDropIsStarted,
      })}
      {...getDragAndDropAttributes(id, DROPZONE_TYPE.PAGE_NEXT, {
        parentId: node.parentId,
        group: node.group,
        childIndex: node.childIndex,
      })}
    >
      <div />
    </div>
  )
}

export default Dropzone
